/* WebComponentFloatingBox template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { PlaceholderIcons } from '@cewe-designsystem/util_placeholder_icons';
import { FloatingBoxComponent } from './cwc-floating-box';

/*
Open: {context.ref.open ? "yes" : "no"}
Activated: {context.ref.activated ? "yes" : "no"}
 */

/**
 * Definition of  parameters that the template needs to work.
 */
interface FloatingBoxTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: FloatingBoxComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const FloatingBoxTemplate: FunctionalComponent<FloatingBoxTemplateProps> = ({ controller }) => (
  <Host>
    <cwc-floating-box-wrapper>
      <cwc-floating-box-header>
        <cwc-floating-box-close onclick={() => controller.onClose()}>
          <slot name={'close-icon'}>
            <svg viewBox={'0 0 24 24'}>{PlaceholderIcons.close()}</svg>
          </slot>
        </cwc-floating-box-close>
      </cwc-floating-box-header>
      <cwc-floating-box-body>
        <slot />
      </cwc-floating-box-body>
    </cwc-floating-box-wrapper>
  </Host>
);

export default FloatingBoxTemplate;
